import React from 'react'
import isPropValid from '@emotion/is-prop-valid'
import _styled from '@emotion/styled'

interface StyledConfig {
  shouldForwardProp?: (prop: string) => boolean
  [key: string]: unknown
}

/**
 * Resolves console warnings where custom props are passed to MUI components.
 * https://github.com/TrackingFirst/eng-docs/blob/master/coding-standards/javascript/standards/standards.md#styling
 */
export const styled = ((
  component: React.JSXElementConstructor<unknown>,
  config: StyledConfig = {},
) => {
  const fullConfig = {
    shouldForwardProp: (prop: string) => isPropValid(prop),
    ...config,
  }
  return _styled(component, fullConfig)
}) as typeof _styled
